import React, { useEffect } from "react";
import { Modal, IconButton, Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const StyledModal = styled(Modal)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& .MuiBackdrop-root": {
    backgroundColor: "rgba(10, 12, 10, 0.92)",
  },
});

const RoundButton = styled(IconButton)({
  position: "absolute",
  color: "white",
  backgroundColor: "rgba(255, 255, 255, 0.12)",
  backdropFilter: "blur(6px)",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.25)",
  },
  zIndex: 2,
});

// onPrev / onNext son opcionales: si no se pasan, no se muestran las flechas
const ImageModal = ({ open, onClose, image, onPrev, onNext, position }) => {
  useEffect(() => {
    if (!open) return undefined;
    const handleKey = (event) => {
      if (event.key === "ArrowLeft" && onPrev) onPrev();
      if (event.key === "ArrowRight" && onNext) onNext();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [open, onPrev, onNext]);

  return (
    <StyledModal open={open} onClose={onClose} aria-label={image?.title || "Foto ampliada"}>
      <Box
        sx={{
          position: "relative",
          width: "100vw",
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          outline: "none",
        }}
        onClick={onClose}
      >
        <RoundButton aria-label="Cerrar" onClick={onClose} sx={{ top: 16, right: 16 }}>
          <CloseIcon />
        </RoundButton>
        {onPrev && (
          <RoundButton
            aria-label="Foto anterior"
            onClick={(e) => {
              e.stopPropagation();
              onPrev();
            }}
            sx={{ left: { xs: 8, md: 24 }, top: "50%", transform: "translateY(-50%)" }}
          >
            <ChevronLeftIcon fontSize="large" />
          </RoundButton>
        )}
        {onNext && (
          <RoundButton
            aria-label="Foto siguiente"
            onClick={(e) => {
              e.stopPropagation();
              onNext();
            }}
            sx={{ right: { xs: 8, md: 24 }, top: "50%", transform: "translateY(-50%)" }}
          >
            <ChevronRightIcon fontSize="large" />
          </RoundButton>
        )}
        {image && (
          <Box
            component="img"
            src={image.src || image.url}
            alt={image.title}
            onClick={(e) => e.stopPropagation()}
            sx={{
              maxWidth: { xs: "94vw", md: "84vw" },
              maxHeight: "86vh",
              display: "block",
              borderRadius: "12px",
              boxShadow: "0 30px 80px rgba(0,0,0,0.5)",
            }}
          />
        )}
        {position && (
          <Typography
            variant="body2"
            sx={{ position: "absolute", bottom: 20, color: "rgba(255,255,255,0.7)", letterSpacing: "0.1em" }}
          >
            {position}
          </Typography>
        )}
      </Box>
    </StyledModal>
  );
};

export default ImageModal;
